import { useInvoiceHistory } from "../../hooks"
import { InvoiceStatusChangeRead } from "../../api/generated"
import {
  HistoryElement,
  HistoryElementContent,
  HistoryElementHeadline,
  HistoryTitle,
  HistoryWrapper,
} from "./InvoiceHistory.styles"

export interface Props {
  invoiceId: number
}

export default function InvoiceHistory(props: Props) {
  const { data, isLoading, isError } = useInvoiceHistory(props.invoiceId)

  function naturalLanguageTransform(statusChange: InvoiceStatusChangeRead) {
    switch (statusChange.status) {
      case "created":
        return "Invoice created"
      case "checked_out":
        return statusChange.user_email
          ? "Checked out by " + statusChange.user_email
          : "Invoice unassigned"
      default:
        return statusChange.status + " by " + statusChange.user_email
    }
  }

  if (isLoading) {
    return <p>Loading...</p>
  }

  if (isError) {
    return <p>Error</p>
  }

  return (
    <HistoryWrapper>
      <HistoryTitle>Invoice activity log</HistoryTitle>
      {data!.map((elem, idx) => {
        return (
          <HistoryElement key={"history_element_" + idx}>
            <HistoryElementHeadline>{elem.created_at}</HistoryElementHeadline>
            <HistoryElementContent>
              {naturalLanguageTransform(elem)}
            </HistoryElementContent>
          </HistoryElement>
        )
      })}
    </HistoryWrapper>
  )
}
